<template>
  <section style="">
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ title }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <div class="columns">
              <div class="column">
                <div class="box">
                  <b-table
                    :data="gifts"
                    :mobile-cards="false"
                    hoverable
                    narrowed
                    sticky-header
                  >
                    <b-table-column
                      field="id"
                      :visible="false"
                      :label="$t('attributes.id')"
                      width="75"
                      centered
                      v-slot="props"
                    >
                      {{ props.row.id }}
                    </b-table-column>

                    <b-table-column
                      field="full_name"
                      :label="$t('attributes.gift_selected_posting')"
                      header-class="nowrap"
                      cell-class="nowrap"
                      v-slot="props"
                    >
                      {{ props.row.full_name }}
                    </b-table-column>
                  </b-table>
                </div>
              </div>

              <div class="column">
                <form-group
                  name="month"
                  attribute="attributes.gift_posting_month"
                  :label="$t('attributes.gift_posting_month')"
                  label-position="on-border"
                >
                  <b-datepicker
                    v-model="selectedMonth"
                    type="month"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :placeholder="
                      $t('message.please_input') +
                        $t('attributes.gift_posting_month')
                    "
                    icon="calendar-today"
                    inline
                    trap-focus
                    @input="onSelectedMonth"
                  >
                    <div class="buttons">
                      <b-button
                        :label="$t('attributes.this_month')"
                        type="is-success"
                        @click="onSelectedThisMonth"
                      />
                      <b-button
                        :label="$t('attributes.last_month')"
                        type="is-info"
                        @click="onSelectedLastMonth"
                      />
                      <b-button
                        :label="$t('attributes.clear')"
                        type="is-danger"
                        @click="onClearMonth"
                      />
                    </div>
                  </b-datepicker>
                </form-group>
              </div>
            </div>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="sending"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.cancel') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ $t('attributes.gift_posting') }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'GiftPostForm',

  props: {
    gifts: {
      type: Array,
      required: true
    },
    sending: {
      type: Boolean,
      required: true
    }
  },
  data() {
    const today = this.$dayjs().toDate()

    return {
      title: this.$t('attributes.gift_posting'),

      minDate: this.$dayjs('2021-01-01').toDate(),
      maxDate: today,
      selectedMonth: today,

      form: {
        gifts: this.gifts.map(g => g.id),
        month: this.formatMonth(today)
      }
    }
  },
  computed: {
    isLoading() {
      return this.sending
    }
  },
  validations() {
    return {
      form: {
        gifts: { required },
        month: { required }
      }
    }
  },
  methods: {
    onSelectedThisMonth() {
      this.selectedMonth = this.$dayjs().toDate()
      this.form.month = this.formatMonth(this.purchaseDate)
    },
    onSelectedLastMonth() {
      this.selectedMonth = this.$dayjs()
        .subtract(1, 'month')
        .toDate()
      this.form.month = this.formatMonth(this.purchaseDate)
    },
    onClearMonth() {
      this.selectedMonth = null
      this.form.month = null
    },
    onSelectedMonth(date) {
      this.form.month = this.formatMonth(date)
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
